import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const marineHullValidationSchema = () =>
  Yup.object({
    marineHullDetails: Yup.object({
      vesselName: requiredText(),
      connectionPort: requiredText(),
      territorialWaters: requiredText(),
      usage: requiredText(),
      builder: requiredText(),
      constructionYear: requiredText(),
      registryPort: requiredText(),
      engineType: requiredText(),
      engineNumber: requiredText(),
      engineYearBuilt: requiredText(),
      engineHorsePower: requiredText()
    })
  });
